import React from 'react';
import { Building2, User as UserIcon, BarChart3, LogOut, TrendingUp } from 'lucide-react';
import { useMetaLang, UM_STRINGS } from '../../i18n/metaReviewLang';

interface UserMenuDropupProps {
  isLeader: boolean;
  onOrganizationClick: () => void;
  onAccountSettingsClick: () => void;
  onAiScoreClick: () => void;
  onUsageClick: () => void;
  onLogout: () => void;
}

/* 旧 styled-components 定義。keyframes `slideUp` は globals.css の
 * `msc-slide-up` へ移設。 */
const MENU_CONTAINER =
  'absolute bottom-full left-3 right-3 mb-2 bg-white border border-warm-border ' +
  'rounded-tasky-sm shadow-card overflow-hidden z-50 ' +
  'animate-[msc-slide-up_0.2s_ease-out]';

const MENU_ITEM_BASE =
  'w-full flex items-center gap-3 px-4 py-3 bg-white border-0 text-left text-[14px] ' +
  'cursor-pointer transition-[background-color] duration-200 hover:bg-warm-hover ' +
  '[&:not(:last-child)]:border-b [&:not(:last-child)]:border-b-gray-100 ' +
  '[&_svg]:shrink-0 [&_span]:flex-1';
const MENU_ITEM_LOGOUT = 'text-destructive'; /* #C96162 */
const MENU_ITEM_DEFAULT = 'text-gray-700'; /* #374151 */

const UserMenuDropup: React.FC<UserMenuDropupProps> = ({
  isLeader,
  onOrganizationClick,
  onAccountSettingsClick,
  onAiScoreClick,
  onUsageClick,
  onLogout
}) => {
  const [lang] = useMetaLang();
  const t = UM_STRINGS[lang];

  return (
    <div className={MENU_CONTAINER}>
      {/* 組織管理 - リーダーのみ */}
      {isLeader && (
        <button className={`${MENU_ITEM_BASE} ${MENU_ITEM_DEFAULT}`} onClick={onOrganizationClick}>
          <Building2 className="w-4 h-4" />
          <span>{t.organization}</span>
        </button>
      )}

      {/* アカウント設定 */}
      <button className={`${MENU_ITEM_BASE} ${MENU_ITEM_DEFAULT}`} onClick={onAccountSettingsClick}>
        <UserIcon className="w-4 h-4" />
        <span>{t.accountSettings}</span>
      </button>

      {/* 活用スコア */}
      <button className={`${MENU_ITEM_BASE} ${MENU_ITEM_DEFAULT}`} onClick={onAiScoreClick}>
        <BarChart3 className="w-4 h-4" />
        <span>{t.aiScore}</span>
      </button>

      {/* AI使用量 - 一時的に非表示 */}
      {/* <button className={`${MENU_ITEM_BASE} ${MENU_ITEM_DEFAULT}`} onClick={onUsageClick}>
        <TrendingUp className="w-4 h-4" />
        <span>AI使用量</span>
      </button> */}

      {/* ログアウト */}
      <button className={`${MENU_ITEM_BASE} ${MENU_ITEM_LOGOUT}`} onClick={onLogout}>
        <LogOut className="w-4 h-4" />
        <span>{t.logout}</span>
      </button>
    </div>
  );
};

export default UserMenuDropup;
